<template>
	<transition name="fade">
		<div class="toast-wrap fixed-100" v-show="show">
			<p class="toast-text center-middle" v-html="text"></p>
		</div>
	</transition>
</template>

<script>
	export default {
		name: 'toastComponent',
		props: {
			text: String,
			time: {
				type: Number,
				default: 2000
			}
		},
		data () {
			return {
				show: false
			}
		},
		watch: {
			show(val) {
				if (val) {
					setTimeout(() => {
						this.show = false
					}, this.time)
				}
			}
		}
	}
</script>

<style scoped>
	.center-middle{
		position: absolute;
		left: 50%;
		top: 50%;
		-webkit-transform: scale(1, 1) translate(-50%, -50%);
		-moz-transform: scale(1, 1) translate(-50%, -50%);
		transform: scale(1, 1) translate(-50%, -50%);
	}
	.toast-wrap {
		z-index: 9999;
	}
	.toast-wrap  .toast-text {
		width: 60%;
		max-width: 480px;
		padding: 2rem 1.2rem;
		-webkit-border-radius: 0.5rem;
		-moz-border-radius: 0.5rem;
		border-radius: 0.5rem;
		background: rgba(0, 0, 0, 0.8);
		color: white;
		text-align: center;
		font-size: 1.4rem;
		z-index: 9999;
	}

	.fade-enter-active,.fade-leave-active {
		transition: 0.3s ease-out;
	}
	.fade-enter {
		opacity: 0;
		transform: scale(1.2);
	}
	.fade-leave-to {
		opacity: 0;
		transform: scale(0.8);
	}
</style>



// WEBPACK FOOTER //
// src/components/common/toast/toast.vue